import React from 'react';
import { useRoute } from '@react-navigation/native';

import { BookingConfirmationNavigationParams } from '@views/shared/interfaces/booking';

import {
  BookingConfirmation,
  ConfirmBookedTimes,
} from '@views/shared/BookingConfirmation';
import NextDaysBooking from '@views/Home/Book/NextDaysBooking';
import Catering from '@views/Home/Book/MeetingRoom/Catering';

export function Confirm() {
  const route = useRoute<any>();
  const {
    areaId,
    bookingId,
    date,
    deskId,
    enabledCateringBooking,
    enabledHalfDayBooking,
    enabledHourlyBooking,
    hasNextDaysBooking,
    location,
    parkingId,
    time,
    type,
  } = route.params as BookingConfirmationNavigationParams;

  return (
    <BookingConfirmation
      location={location}
      date={date}
      time={ConfirmBookedTimes(time)}
      type={type}
    >
      {hasNextDaysBooking ? (
        <NextDaysBooking
          currentBookedType={type}
          enabledHalfDayBooking={enabledHalfDayBooking}
          enabledHourlyBooking={enabledHourlyBooking}
          params={{ areaId, deskId, parkingId }}
        />
      ) : null}
      {enabledCateringBooking ? <Catering bookingId={bookingId} /> : null}
    </BookingConfirmation>
  );
}
